module.exports = __webpack_public_path__ + "img/vehicle_guide.dc1051f5.jpg";